import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { DialogContent } from '@mui/material';
import { updateConnection } from '../../services/authSlice';
import ConnectionForm from './ConnectionForm';
import connectionValidationSchema from '../../../../helpers/user/connectionValidationSchema';

function UpdateConnection({
  connection, handleClose, errorMessage, allowed, isLoading,
}) {
  const dispatch = useDispatch();
  const validationSchema = connectionValidationSchema();

  return (
    <DialogContent>
      <div>
        <Formik
          initialValues={connection}
          validationSchema={validationSchema}
          onSubmit={(data) => {
            const allowedData = allowed.reduce((formData, value) => (
              { ...formData, [value]: data[value] }
            ), {});
            const newData = {
              id: data.id,
              updatedData: allowedData,
            };
            dispatch(updateConnection(newData));
          }}
        >
          <ConnectionForm
            type="edit"
            handleClose={handleClose}
            errorMessage={errorMessage}
            isLoading={isLoading}
          />
        </Formik>
      </div>
    </DialogContent>
  );
}

UpdateConnection.propTypes = {
  connection: PropTypes.shape({}).isRequired,
  handleClose: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  allowed: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
};

UpdateConnection.defaultProps = {
  errorMessage: null,
  allowed: ['lastName', 'firstName', 'phoneNumber', 'relationshipType'],
  isLoading: false,
};

export default UpdateConnection;
